import { render, staticRenderFns } from "./ProfessionalAccess.vue?vue&type=template&id=26b32fd6&scoped=true"
import script from "./ProfessionalAccess.vue?vue&type=script&lang=js"
export * from "./ProfessionalAccess.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalAccess.vue?vue&type=style&index=0&id=26b32fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b32fd6",
  null
  
)

export default component.exports